import React from 'react';

import type { ConnectionState, DevContextProps } from './../../../ricos-context/index.js';
import { DevContext } from './../../../ricos-context/index.js';
import { unreachable } from './../../../_shared/uncreachable.js';

import { Button } from '../components/Button.js';
import { jsonTreeTheme } from '../theme.js';

const errorStatus = {
  Connection: -1,
  Permission: 403,
  NotFound: 404,
  Server: 500,
  Throttle: 429,
} as const;

type ErrorStatus = (typeof errorStatus)[keyof typeof errorStatus];

const inputStyles = {
  background: 'transparent',
  color: jsonTreeTheme.base0B,
  padding: '2px',
  border: `1px solid ${jsonTreeTheme.base0B}`,
};

export const RicosNetworkConditionsTab: React.FC = () => {
  const devContext = React.useContext(DevContext) as DevContextProps;
  const { connectionState, setConnectionState } = devContext;

  if (!setConnectionState || !connectionState) {
    return <div>Dev context not configured</div>;
  }
  return (
    <div style={{ marginLeft: '0.875em', color: jsonTreeTheme.base0D }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={() => setConnectionState({ type: 'NO_MODIFICATION' })}>
          Reset to default
        </Button>
      </div>
      <div>
        <label style={{ display: 'block' }}>
          <span style={{ minWidth: '60px', display: 'inline-block' }}>CRUD</span>
          <select
            style={{
              marginLeft: '4px',
              width: '120px',
              ...inputStyles,
            }}
            value={connectionState.type}
            onChange={e => {
              const value: ConnectionState['type'] = e.currentTarget
                .value as ConnectionState['type'];
              switch (value) {
                case 'BROKEN': {
                  setConnectionState({
                    type: 'BROKEN',
                    delay: 0,
                    status:
                      'status' in connectionState ? connectionState.status : errorStatus.Connection,
                  });
                  break;
                }
                case 'DELAYED': {
                  setConnectionState({ type: 'DELAYED', delay: 1 });
                  break;
                }
                case 'NO_MODIFICATION': {
                  setConnectionState({ type: 'NO_MODIFICATION' });
                  break;
                }
                default:
                  throw unreachable(value);
              }
            }}
          >
            {['NO_MODIFICATION', 'BROKEN', 'DELAYED'].map(key => (
              <option key={key} value={key}>
                {key}
              </option>
            ))}
          </select>
        </label>
        {connectionState.type === 'BROKEN' && (
          <label style={{ display: 'block' }}>
            <span style={{ display: 'inline-block', marginTop: '8px', marginLeft: '64px' }}>
              {' '}
              with status
            </span>
            <select
              style={{ marginLeft: '4px', width: '120px', ...inputStyles }}
              value={connectionState.status}
              onChange={e => {
                const value: ErrorStatus = parseInt(e.currentTarget.value, 10) as any;
                setConnectionState({ ...connectionState, status: value });
              }}
            >
              {Object.entries(errorStatus).map(([label, status]) => (
                <option key={status} value={status}>
                  {label} ({status})
                </option>
              ))}
            </select>
          </label>
        )}
        {connectionState.type !== 'NO_MODIFICATION' && (
          <label style={{ display: 'block' }}>
            <span style={{ display: 'inline-block', marginTop: '8px', marginLeft: '64px' }}>
              {' '}
              delay by
            </span>
            <input
              style={{ marginLeft: '4px', width: '40px', ...inputStyles }}
              type="number"
              value={connectionState.delay}
              min={0}
              onChange={e => {
                const value: number = Number(e.currentTarget.value) || 0;
                setConnectionState({ ...connectionState, delay: value });
              }}
            />{' '}
            seconds
          </label>
        )}
      </div>
    </div>
  );
};
